import React from 'react';
import { useTranslation } from 'react-i18next';

const LANGS = [
  { code: 'en', short: 'EN', native: 'English' },
  { code: 'ar', short: 'ع', native: 'العربية' },
];

const LanguageSwitcher = ({ className = '' }) => {
  const { i18n } = useTranslation();
  const current = (i18n.language || 'en').startsWith('ar') ? 'ar' : 'en';

  const changeLanguage = (code) => {
    if (code === current) return;
    i18n.changeLanguage(code);
    localStorage.setItem('selectedLanguage', code);
    localStorage.setItem('i18nextLng', code);
    document.documentElement.dir = code === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = code;
    // LanguageContext + legacy translation helpers read on mount, so refresh once
    window.location.reload();
  };

  return (
    <div
      data-testid="language-switcher"
      className={`inline-flex items-center rounded-full border border-gray-200 dark:border-white/15 bg-gray-50 dark:bg-white/5 p-1 ${className}`}
    >
      {LANGS.map((lang) => (
        <button
          key={lang.code}
          onClick={() => changeLanguage(lang.code)}
          data-testid={`language-option-${lang.code}`}
          aria-label={lang.native}
          aria-pressed={current === lang.code}
          className={`min-w-[2.75rem] rounded-full px-3 py-1.5 text-xs font-semibold transition-all duration-300 ${
            current === lang.code
              ? 'bg-white dark:bg-white/15 text-gray-900 dark:text-white shadow-sm'
              : 'text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
          }`}
        >
          {lang.short}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
